import { Business } from 'model';
import bannerDefault from '../assets/Banner_default.png';
import bannerFood from '../assets/busBanner_food.jpg';
import bannerGrocery from '../assets/busBanner_grocery.jpg';
import bannerRetail from '../assets/busBanner_retail.jpg';
import GenericBusinessIcon from '../assets/buildingIcon.png';

export type LogoBanner = { logo: string; banner: string };
const genericImages = [bannerDefault, bannerFood, bannerGrocery, bannerRetail, GenericBusinessIcon];
export function isGenericImage(image: string): boolean {
	return genericImages.includes(image);
}

/**
 * Get the logo and banner urls for a business
 * @param { Business} business The business
 * @returns { LogoBanner } The logo and banner urls
 */
export const getBusinessImages = (business: Business): LogoBanner => {
	let logo = '';
	let banner = '';
	if (business.logo !== '') {
		logo = `api/business/image/${business._id}/${business.logo}`;
	} else if (business.logoURL !== '') {
		logo = business.logoURL;
	} else {
		logo = GenericBusinessIcon;
	}

	if (business.banner !== '') {
		banner = `api/business/image/${business._id}/${business.banner}`;
	} else if (business.bannerURL !== '') {
		banner = business.bannerURL;
	} else {
		banner =
			business?.businessType === 'fooddrink'
				? bannerFood
				: business?.businessType === 'retail'
				? bannerRetail
				: business?.businessType === 'grocery'
				? bannerGrocery
				: bannerDefault;
	}

	return { logo, banner };
};
